// =============================================================================
// MAIN APP COMPONENT
// =============================================================================

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { HomePage } from '@/pages/HomePage';
import { TermsPage } from '@/pages/TermsPage';
import { PrivacyPage } from '@/pages/PrivacyPage';
import { PaymentPage } from '@/pages/PaymentPage';
import { PaymentSuccessPage } from '@/pages/PaymentSuccessPage';
import { UnsubscribePage } from '@/pages/UnsubscribePage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { ToastProvider } from '@/contexts/ToastContext';
import { ShoppingBagProvider } from '@/contexts/ShoppingBagContext';
import { ToastPortal, BackToTop } from '@/components/ui';
import { ShoppingBagModal } from '@/components/ShoppingBag';
import { NotFoundHandler } from '@/components/NotFoundHandler';
import '@/styles/main.scss';

function App() {
  return (
    <HelmetProvider>
      <ToastProvider>
        <ShoppingBagProvider>
          <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
        <NotFoundHandler>
          <div className="app">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/payment" element={<PaymentPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/unsubscribe" element={<UnsubscribePage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </div>
        </NotFoundHandler>
        <ToastPortal />
        <BackToTop />
        <ShoppingBagModal />
      </Router>
      </ShoppingBagProvider>
      </ToastProvider>
    </HelmetProvider>
  );
}

export default App;
